import { Record } from "@siteimprove/alfa-record";
import { Sequence } from "@siteimprove/alfa-sequence";
export * from "./tags/index.js";
export * from "./requirements/index.js";
import * as experimentalRules from "./experimental.js";
export { experimentalRules };
import * as deprecatedRules from "./deprecated.js";
export { deprecatedRules };
import * as rules from "./rules.js";
import version from "./version.js";
/**
 * @public
 */
export const alfaVersion = version;
/**
 * An immutable record of individual rules. The type of each individual rule is
 * preserved in the record.
 *
 * @public
 */
export const Rules = Record.of(rules);
/**
 * A list of all available rules joined under a single type. The type of each
 * rule is not preserved in the list as the types have been flattened.
 *
 * @public
 */
const FlattenedRules = Sequence.from(Rules.values());
export default FlattenedRules;
export * from "./common/act/diagnostic.js";
export * from "./common/act/group.js";
export * from "./common/act/question.js";
//# sourceMappingURL=index.js.map